export const brandOptions = ['Bluehost', 'HostGator'];

export const apiBaseUrlOptions = [
  'https://hosting-alpha.uapi.newfold.com',
  'https://hosting-beta.uapi.newfold.com',
  'https://hosting-staging.uapi.newfold.com',
  'https://hosting.uapi.newfold.com',
];
